import React, { useEffect, useState } from 'react'
import { Loading } from '@dasa-health/components-react'
import { LoadingContainer } from './styles'
import { useHistory } from 'react-router-dom'
import { useUnicoService } from 'services/unico'
import { UNICO_CONSTANTS } from 'redesign/constants'
import { SESSION_STORAGES_KEYS } from 'constants/sessionStorages'
import { ROUTES_PATH } from 'constants/routesPath'
import { BiometyDataType } from 'typings/unico'
import { FaceRecognitionSuccessScreen } from 'pages/FaceRecognitionSuccessScreen'
import { clearStorage } from 'utils'

export const FaceBiometricsScreen: React.FC = () => {
    const { getCheckBiometryResult } = useUnicoService()
    const history = useHistory()
    const [loadingCheckSessionStorageData, setLoadingCheckSessionStorageData] = useState(false)
    const [biometrySuccess, setBiometrySuccess] = useState(false)

    const biometyDataLS: BiometyDataType = JSON.parse(sessionStorage.getItem(UNICO_CONSTANTS.STORAGE)!)
    const redirectTo = sessionStorage.getItem(SESSION_STORAGES_KEYS.REDIRECT_TO_URL)
    const isRecoverPassword = biometyDataLS?.origin === UNICO_CONSTANTS.ORIGIN.RECOVER
    const isPasswordChanged = biometyDataLS?.isPasswordChanged
    const hasContacts = biometyDataLS?.contacts
    const origin = biometyDataLS?.origin
    const urlCallBack = origin === 'otp' ? '/entrar/otp/' : '/recuperar-senha'

    const redirectUrlAfterRecover = `${UNICO_CONSTANTS.RECOVER_PASSWORD_STEP}${redirectTo ? `&redirectTo=${redirectTo}` : ''}`

    function redirectToLogin() {
        history.push(ROUTES_PATH.SIGN_IN)
    }

    function redirectToLoginWithModalError() {
        sessionStorage.setItem('@LiviaAuth:ShowSignUpModalError', 'true')
        history.push(ROUTES_PATH.SIGN_IN)

        setTimeout(() => {
            sessionStorage.removeItem('@LiviaAuth:ShowSignUpModalError')
        }, 1000)
    }

    function checkSessionStorageData() {
        setLoadingCheckSessionStorageData(true)
        if (biometyDataLS?.federalTaxId && biometyDataLS?.id && biometyDataLS?.origin) {
            setLoadingCheckSessionStorageData(false)
            return
        }

        redirectToLogin()
    }

    useEffect(() => {
        checkSessionStorageData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        async function checkBiometry() {
            try {
                const { status } = await getCheckBiometryResult(biometyDataLS?.federalTaxId!, biometyDataLS?.id!)

                if (status === UNICO_CONSTANTS.STATUS.SUCCESS) {
                    if (isRecoverPassword) {
                        isPasswordChanged ? setBiometrySuccess(true) : history.push(redirectUrlAfterRecover)
                    } else {
                        setBiometrySuccess(true)
                    }
                }
            } catch {
                if (hasContacts?.length) {
                    history.replace(`${urlCallBack}?step=0&erro=true`)
                    return
                }
                redirectToLoginWithModalError()
                clearStorage([UNICO_CONSTANTS.STORAGE, SESSION_STORAGES_KEYS.REDIRECT_TO_URL, SESSION_STORAGES_KEYS.CONTACTS_BIOMETRY])
            }
        }

        checkBiometry()
    }, [])

    if (loadingCheckSessionStorageData) {
        return (
            <LoadingContainer>
                <Loading />
            </LoadingContainer>
        )
    }

    if (biometrySuccess) {
        return <FaceRecognitionSuccessScreen />
    }

    return (
        <LoadingContainer>
            <Loading />
        </LoadingContainer>
    )
}
